import http from '@/axios/http';

export const login = (parameters) => {
  return http.post('/api/login', parameters);
};

export const logout = (parameters) => {
  return http.post('/api/logout', parameters);
};

export const getUserInfo = (parameters) => {
  return http.post('/api/get_logined_bser', parameters);
};
